var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-form table-responsive" }, [
    _c("table", { staticClass: "table" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.transactionList, function (transaction) {
          return _c("tr", { key: transaction.id }, [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(_vm._s(transaction.amount) + " €"),
            ]),
            _vm._v(" "),
            _c("th", [
              _vm._v(_vm._s(_vm._f("ddMMyyyyHHmm")(transaction.date)) + " "),
            ]),
            _vm._v(" "),
            transaction.type === "SPEND"
              ? _c("th", [
                  _c("span", { staticClass: "badge badge-warning py-1 px-2" }, [
                    _vm._v(" SPEND "),
                  ]),
                ])
              : transaction.type === "DEPOSIT"
              ? _c("th", [
                  _c("span", { staticClass: "badge badge-success py-1 px-2" }, [
                    _vm._v(" DEPOSIT "),
                  ]),
                ])
              : _vm._e(),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Tutar")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Tarih")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Tipi")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }